module.exports = __webpack_public_path__ + "img/home1.79d1bae8.jpg";